import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import { localTime, convertTimeLetter, renderTimeRange } from '@helpers';
import { modalFieldBg, SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

export default ({ data, C, scale = initialScale, font = initialFont }: { data: any; C: any; scale?: ScaleFunction; font?: typeof initialFont }) => {
  const isBatch = Boolean(data?.productionBatchId);
  const cycleTime = convertTimeLetter(data?.batch?.actualCycleTimeAverageInSeconds) as any;
  const setupTime = convertTimeLetter(data?.batch?.actualSetupTimeInSeconds) as any;

  const renderTime = ({ h, m, s }: { h: string; m: string; s: string }) => {
    const hN = Number(h);
    const mN = Number(m);
    const sN = Number(s);

    const seconds = (() => (sN > 0 ? ` ${sN}${i18n.t('s')}` : ''))();

    if (hN > 0) {
      return `${hN}${i18n.t('h')} ${mN}${i18n.t('m')}${seconds}`;
    }
    if (mN > 0) {
      return `${mN}${i18n.t('m')}${seconds}`;
    }

    return `${sN}${i18n.t('s')}`;
  };

  //   stop here - show batch not found if id exist but not data

  return (
    <View
      style={{
        width: '100%',
        backgroundColor: C(modalFieldBg),
        paddingHorizontal: scale(18),
        paddingVertical: scale(13),
        marginBottom: scale(18),
        borderRadius: scale(SCREEN_BORDER_RADIUS),
      }}
    >
      <Text style={[font.Body, { color: C('Label/Light/Tertiary'), marginBottom: scale(4) }]}>{i18n.t(isBatch ? 'Batch' : 'NC File')}</Text>
      <Text style={[font.Body, { color: C('Label/Light/Primary'), marginBottom: scale(isBatch ? 4 : 0) }]}>{data?.ncFileName}</Text>
      {isBatch && (
        <View>
          <Text style={[font.Headline, { color: C('Label/Light/Primary'), marginBottom: scale(4) }]}>{data?.batch?.machineFullName}</Text>
          <Text style={[font.Body, { color: C('Label/Light/Primary'), marginBottom: scale(4) }]}>
            {renderTimeRange(data?.batch?.startedOn, data?.batch?.endedOn)}
          </Text>
          <Text style={{ marginBottom: scale(4) }}>
            <Text style={[font.Body, { color: C('Label/Light/Primary') }]}>{renderTime(cycleTime)}</Text>
            <Text style={[font.Body, { color: C('Label/Light/Tertiary') }]}>
              {' '}
              {i18n.t('cycle Time')}
              {'  '}|{'  '}
            </Text>
            <Text style={[font.Body, { color: C('Label/Light/Primary') }]}>{renderTime(setupTime)}</Text>
            <Text style={[font.Body, { color: C('Label/Light/Tertiary') }]}> {i18n.t('setup Time')}</Text>
          </Text>
          <Text>
            <Text style={[font.Body, { color: C('Label/Light/Primary') }]}>{data?.batch?.quantity}</Text>
            <Text style={[font.Body, { color: C('Label/Light/Tertiary') }]}> {i18n.t('Pieces Ready')}</Text>
          </Text>
        </View>
      )}
    </View>
  );
};
